import { logger } from './logger';

export type AuthEvent =
  | 'login.success'
  | 'login.failure'
  | 'logout'
  /** The credential stopped working; the session was ended without the user asking. */
  | 'session.expired'
  | 'token.refresh'
  | 'token.refresh.failure'
  | 'hydrate.success'
  | 'hydrate.failure'
  | 'otp.sent'
  | 'otp.verified'
  | 'otp.failure'
  | 'otp.resent'
  /** The signed-in user changed their own password (profile menu or first sign-in). */
  | 'password.changed';

/**
 * Deliberately thin, and deliberately PII-free: no email addresses, no tokens.
 * Swap the logger call for a real audit sink when one exists.
 */
export function logAuthEvent(event: AuthEvent, meta?: Record<string, string | number>): void {
  logger.info('audit', event, meta ?? {});
}
